// @ts-nocheck
import { useEffect, useState } from 'react'
import { Button } from "@/components/ui/button"

import SidePanel from './SidePanel'
import { TeamSettingsForm } from './Settings/SettingsForm'
import { AdminPermissionList } from './Admins/AdminPermissionList'
import useAdminStore from '@store/adminStore';
import { Title } from '@radix-ui/react-toast';
import { useOutletContext } from 'react-router-dom';
import { useAuth } from '@/auth/clerkShim';

export default function SettingsModal({ open, onClose, onSubmit, title = 'Settings', subtitle, data, defaultConfig, parentTiers, entityType }) {
  // Sport is single-sourced from the org and mirrored onto every entity's
  // `sports` array (ADR 0010) — every caller passed exactly this derivation,
  // so derive it from `data` instead of threading a separate prop.
  const sport = data?.sports?.[0] || 'basketball';
  const [isOpen, setIsOpen] = useState(false)
  // const [admins, setAdmins] = useState([]);
  const { getToken } = useAuth();
  const { leagueName } = useOutletContext() as any;
  const { admins, getAdminsByLeagueName } = useAdminStore((state: any) => ({
    admins: state.admins,
    getAdminsByLeagueName: state.getAdminsByLeagueName(getToken),
  }));

  useEffect(() => {
    console.log('SettingsModal::leagueName: ', leagueName);
    getAdminsByLeagueName(leagueName, (res) => {
      console.log('getAdminByLeagueName::result: ', res);
      // setAdmins(res);
    });
  }, []);
  // `topLevel` carries top-level entity fields (startDate) that must stay OUT
  // of the config payload; legacy consumers that ignore the second arg are
  // unaffected (they also never pass entityType, so the field never renders).
  const handleSubmitSuccess = (values: any, topLevel?: { startDate?: string }) => {
    onSubmit(values, topLevel);
    onClose();
    // setIsOpen(false)
  }

  console.log('SettingsModal::admins: ', admins);

  return (
    <SidePanel
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      description="Make changes to your configuration here. Click save when you're done."
      bodyClassName="p-0 overflow-hidden flex"
    >
      <TeamSettingsForm onSubmitSuccess={handleSubmitSuccess} sport={sport} data={data} defaultConfig={defaultConfig} parentTiers={parentTiers} entityType={entityType} />
    </SidePanel>
  )
}

